import { AlertTriangle, Clock, CheckCircle2, Wrench } from "lucide-react";

const CFG = {
  open: { label: "Offen", Icon: AlertTriangle, bg: "#FEF2F2", border: "#FCA5A5", color: "#B91C1C" },
  in_progress: { label: "In Bearbeitung", Icon: Clock, bg: "#FFF7ED", border: "#FED7AA", color: "#C2410C" },
  completed: { label: "Erledigt", Icon: CheckCircle2, bg: "#F0FDF4", border: "#86EFAC", color: "#15803D" },
  external_service_required: { label: "An Fachfirma übergeben", Icon: Wrench, bg: "#EFF6FF", border: "#BFDBFE", color: "#1D4ED8" },
};

export const statusLabel = (s) => (CFG[s] || CFG.open).label;

export const StatusBadge = ({ status, size = "md" }) => {
  const c = CFG[status] || CFG.open;
  const Icon = c.Icon;
  const lg = size === "lg";
  return (
    <span data-testid="status-badge" role="status"
      className="inline-flex items-center gap-1.5 rounded-full font-bold"
      style={{ background: c.bg, border: `1px solid ${c.border}`, color: c.color, padding: lg ? "6px 14px" : "4px 10px", fontSize: lg ? 14 : 12 }}>
      <Icon size={lg ? 16 : 14} aria-hidden="true" /> {c.label}
    </span>
  );
};
